import $ from 'jquery';

const bourseLeftMenuActiveItems = function () {
    // sets the 'is-current' classes
	var currentChannelBreadcrumb = $("#bourse-breadcrumb-channel-ids").val();
	if (currentChannelBreadcrumb != undefined) {
		var channels = currentChannelBreadcrumb.split(",");
		// channels.length-1 because I don't care about the home channel
		for (var i = 0; i < channels.length - 1; i++) {
			var ch = channels[i];
			var $item = $("li.dcw_menu-brs_item a[data-channelid=" + ch + "]");

			if($item.length) {
				var $liItem = $item.parent(".dcw_menu-brs_item");
				if($liItem.hasClass("dcw_menu-brs_menu-item")){
					// it's a level 2 item
                    $liItem.addClass("is-current");
                	$liItem.attr("aria-current","true");
				} else {
                    // it's a level 3 item
                    $liItem.parents('li').addClass("is-current");
                	$liItem.addClass("is-active");
                    var $buttonItem = $liItem.parent(".dcw_menu-brs_list").siblings("button.js-menu-brs_toggle");
                    $buttonItem.addClass("is-open");
				}

                break;
            }
		}
	}
};

export {bourseLeftMenuActiveItems};


// WEBPACK FOOTER //
// ./src/js/cms/pri/bourse-left-menu.js